

import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import routes from './router'
import './js/rem.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'







axios.defaults.baseURL = 'https://wx.fzgjmy.com/microstore'; 


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';


Vue.use(AlertPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(ConfirmPlugin)

Vue.use(VueAwesomeSwiper)
Vue.use(VueRouter)

const wx = Vue.wechat
const http = Vue.http

Vue.config.productionTip = false

const router = new VueRouter({
routes
})
Vue.use( router)
new Vue({
el: '#app',
router,
template: '<App/>',
components: { App }
})





// WEBPACK FOOTER //
// ./src/main.js